import React from "react"

// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
const ClaimContext = React.createContext()

export const ClaimProvider = ClaimContext.Provider
export const ClaimConsumer = ClaimContext.Consumer

export default ClaimContext
